svg4everybody();

function servicesList() {

  var ps;

  // Скроллбар на меню

  var $servicesList = $('.js-services-list');

  initScrollingMenu($servicesList);

  



  $(document).on('touchstart', function(e){

    ps.destroy();

  }).on('touchend', function(){

    initScrollingMenu($servicesList);

  })



  // Стартовое значение скролла

  $servicesList[0].scrollLeft = 0;



  var coordX;

  var currentScrollLeft;

  var isClicked = null;



  // Драг меню

  $servicesList.on('mousedown', function(e) {

    e.preventDefault();



    coordX = e.pageX;

    currentScrollLeft = $servicesList[0].scrollLeft;



    isClicked = true;

  })



  $('body').on('mousemove', function(e) {

    if (isClicked) {

      $servicesList[0].scrollLeft = currentScrollLeft - (e.pageX - coordX);

      if ($servicesList[0].scrollLeft > 0) {

        $(".main-nav").addClass("has-back-btn");

        $(".js-header-menu-back").css({"display" :"inline-flex"});

      } else {

        $(".main-nav").removeClass("has-back-btn");

        $(".js-header-menu-back").css({"display" :"none"});

      }

    }

  }).on('mouseup', function() {

    isClicked = false;

  });



  // Скролл по клику на "Еще"

  $('.js-header-menu-more').on('click', function(e) {

    e.stopPropagation();

    scroll($(this),$servicesList,"left");

  });

  // Скролл по клику на "Назад"

  $('.js-header-menu-back').on('click', function(e) {

    e.stopPropagation();

    scroll($(this),$servicesList,"right");

  });



  function initScrollingMenu(elem) {

  ps = new PerfectScrollbar(elem[0], {

    suppressScrollY: true

  });

}

}



function scroll(cont,servicesList,direction) {

  var $firstHiddenElem;

  var $this = cont;

  var gradientWidth = 15;

  var rightCoord;

  var leftCoord;

  var difference;

  // Чекаем первый элемент за пределом экрана + ширина кпопки "еще" + градиент этой кнопки и скроллим его правой части

  $($('.js-services-list-item').get().reverse()).each(function() {

    rightCoord = $(this).offset().left + $(this).outerWidth();

    leftCoord = $(this).offset().left;

    switch (direction) {

      case "left":

        if (rightCoord > $(window).outerWidth() - $this.outerWidth() - gradientWidth) {

          $firstHiddenElem = $(this);

          difference = rightCoord - $(window).outerWidth() +

          $this.outerWidth() + gradientWidth + 1;

        }

      break

      case "right":

        if (leftCoord < $this.outerWidth() + gradientWidth) {

          $firstHiddenElem = $(this);

          difference = leftCoord;

        }

      break

    }

  });

  if (!$firstHiddenElem) {

    return;

  }

  switch (direction) {

    case "left":

      servicesList.animate({ scrollLeft: servicesList[0].scrollLeft + difference }, 300);

      if (!$(".main-nav").hasClass("has-back-btn")) {

        $(".main-nav").addClass("has-back-btn");

        $(".js-header-menu-back").css({"display" :"inline-flex"});

      }

    break

    case "right":

      servicesList.animate({ scrollLeft: difference }, 300);

      $(".main-nav").removeClass("has-back-btn");

      $(".js-header-menu-back").css({"display" :"none"});

    break

  }

}


function mainSliderInit(){
  $('.js-main-slider').slick({
    fade: true,
    adaptiveHeight: true,
    arrows: false,
    dots: true,
    zindex: 100,
    autoplay: true,
    pauseOnHover: false,
    pauseOnFocus: false,
    autoplaySpeed: 5000,
    swipe : false
  });
}

function otherErrorsSliderInit() {
    $('.similar-errors-slider').slick({
        fade: false,
        adaptiveHeight: true,
        arrows: false,
        dots: true,
        zindex: 100,
        autoplay: false,
        pauseOnHover: true,
        pauseOnFocus: true,
        autoplaySpeed: 5000,
        swipe: true
    });
}


var ts;
$('.js-main-slider').bind('touchstart', function (e){
   ts = e.originalEvent.touches[0].clientX;
});

var vW = $(window).width() / 3

$('.js-main-slider').bind('touchend', function (e){
   var te = e.originalEvent.changedTouches[0].clientX;
   if(ts > te + vW){
      $(this).slick('slickNext');
   }else if(ts < te - vW){
      $(this).slick('slickPrev');
   }
});


var isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;
function specialService() {
   $('.js-service-slider').each(function () {
     var parent = $(this).parent();
       $(this).slick({
       infinite: true,
       speed: 800,
       slidesToShow: 2,
       centerMode: false,
       variableWidth: true,
       adaptiveHeight: false,
       arrows: true,
       dots: false,
       autoplay: true,
       autoplaySpeed: $(this).data('autoplay') || false,
       swipe: true,
       prevArrow: $('.slick-prev', parent),
       nextArrow: $('.slick-next', parent),
       responsive: [{
         breakpoint: 768,
         settings: {
             centerMode: true,
             dots: true,
         }
       }]
     });
       if (!isMobile) {
           parent.hover(function () {
               $(this).find('button').toggleClass('slick-arrow--active');
           })
       }
   });
 }

function reviewsSlider() {
  window.slider = $('.reviews-slider').not('.slick-initialized').each(function() {
    $(this).slick({
      fade: true,
      adaptiveHeight: true,
      arrows: false,
      dots: true,
      zindex: 100,
      autoplay: true,
      pauseOnHover: false,
      pauseOnFocus: false,
      autoplaySpeed: 5000,
      swipe: true
    });
  });

  if (document.querySelector('.reviews-slider .testimonial__body')) {
    const reviewsBody = document.querySelectorAll('.reviews-slider .testimonial__body');

    function mutationHandler(slide) {
      let observer = new MutationObserver(function() {
        const openButton = slide.querySelector('.testimonial__body-open'),
              body = slide.querySelector('.testimonial__body');

        openButton.style.display = 'block';
        body.classList.remove('show');
        body.classList.add('hide');
      });

      observer.observe(slide, {
        attributeFilter: ['class'],
      })
    }

    reviewsBody.forEach(body => {
      if (body.scrollHeight !== body.clientHeight) {

        body.classList.add('hide');

        const openButton = document.createElement('span'),
              marginBottomBody = parseInt(window.getComputedStyle(body).marginBottom);

        openButton.classList.add('testimonial__body-open');
        openButton.textContent = 'Читать полностью'
        body.before(openButton);

        openButton.addEventListener('click', () => {
          const nextEl = openButton.nextElementSibling,
                sliderList = nextEl.closest('.slick-list.draggable');

          let bodyHeight = body.scrollHeight;

          if (document.body.clientWidth < 768) {
            bodyHeight = parseInt(sliderList.style.height) + (body.scrollHeight - body.clientHeight);
          }

          openButton.style.display = 'none';

          sliderList.style.height = bodyHeight + marginBottomBody + 'px';

          nextEl.classList.remove('hide');
          nextEl.classList.add('show');

          mutationHandler(body.closest('.reviews-slider__item'));
        })
      }
    })
  }

  var options = {
      root: null,
      rootMargin: '0px',
      threshold: 0,
  };

  // Включаем/выключаем слайдер, если он появляется/исчезает в пределах вьюпорта
  var observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
          if (entry.isIntersecting) {
              var slider = entry.target;

              $(entry.target).slick('slickPlay');
          } else {
              $(entry.target).slick('slickPause');
          }
      })
  }, options);

  $('.reviews-slider').each(function(item) {
      observer.observe(this);
  });
}



function gallerySliderInit(){


		function initSlider() {
		  $('.js-gallery-slider').slick({
		    adaptiveHeight: true,
		    arrows: false,
		    dots: true,
		    zindex: 100,
		    slide: '.gallery-works__row',
		    mobileFirst: true,
		    responsive: [
              {
	              breakpoint: 1024,
	              settings: 'unslick'
              },
           
            
		     ]
		  });
		}

	// if ($(window).width() < 1024 ) {
		initSlider();

	// }

	var flag = false;

	if ($(window).width() > 1024) {
		flag = true
	}

	$(window).on('resize', function(event) {

		if ($(this).width() < 1024) {

			if (flag) {
			 initSlider();
			}

			flag = false
		} else {
			flag = true 
		}
	});
}

  // if ($(window).width() > 1024) {

  //   $(".js-services-list-item.has-submenu .main-nav__link").on('click', function(event) {

  //     event.preventDefault();



  //     var $parent = $(this).closest('.js-services-list-item');

  //     showMenuDesk($parent, event);


  //     if (!$(this).is('.is-clicked') && $parent.is('.is-opened')) {
  //       event.preventDefault();
  //     }

  //     $(this).addClass('is-clicked');

  //   });

  // }



  function mainNav() {


    // iOS detect
    var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    if (iOS) {
      $('body').addClass('isIos');
    }

    /*Скрытие активного контентного меню при скролле или ресайзе окна*/
    $(window).on("resize", function() {
      hideOpened();
    })
    /*Скрытие по нажатию на область документа.*/
    $(window).on("click", function(e) {
      if (!isOnSubcontent($(e.target)) &&
        !$(e.target).parents().hasClass("js-services-list-item")) {
        hideOpened()
      }
    })

    function isOnSubcontent(obj) {
      return obj.parents().hasClass("subcontent")
    }


    /*Ховер на элементы с обычными подменюшками*/
    $(".submenu").each(function() {
      /*set submenu postition*/
      var submenu = $(this);
      var cont = $(this).parents(".js-services-list-item");
      var contList = $(this).parents(".js-services-list");
      var vw = $(window).width();
      submenu.addClass('subcontent');
    });


    var mainMenuClickFlag = false;

    /*Ховер на подменюшки с контентом*/

      // $(".js-services-list-item").hover(
      //    function (e) {
      //      showMenuDesk($(this), e);
      //    },
      //    function (e) {
      //      hideOpened();
      //      $("body").removeClass("no-overflow");
      //      $("body").css({"padding-right": "0"});
      //    }
      //  );

      $(".js-services-list-item.has-submenu .main-nav__link").on('click', function(event) {
          if ($(window).width() > 1024) {
                var $parent = $(this).closest('.js-services-list-item');
                showMenuDesk($parent, event);

                if (!$(this).is('.is-clicked') && $parent.is('.is-opened')) {
                  event.preventDefault();
                }

                $(this).addClass('is-clicked');
          }
      });






    $(".js-services-list-item").on("click", function(e) {
      var vw = $(window).width();
      var contList = $(this).parents(".js-services-list");
     /* if (vw < 768) {
        var ifcarCard = ($(e.target).hasClass("car-card") || $(e.target).parent().hasClass("car-card"))
        if ($(this).hasClass("has-submenu") && !($(e.target).hasClass("submenu__link")) && !ifcarCard) {
          e.preventDefault();
          openSubcontent($(this), contList)
        }
      }*/
      if (vw >= 768 && vw <= 1024) {
        showMenuDesk($(this), e);

      }
    })

    function showMenuDesk(obj, e) {
      var vw = $(window).width();
      var scrollbarWidth = window.innerWidth - document.body.clientWidth;
      var subcontent = obj.find('.subcontent');
      var contList = obj.parents(".js-services-list");
      var headerHeight = $(".header").outerHeight();
      var bottomHeaderHeight = $('.header__bottom').outerHeight();
      /*mobile handle*/

      var submenu = obj.find(".submenu");
      if (vw >= 768 && vw <= 1024) {
        var ifcarCard = ($(e.target).hasClass("car-card") || $(e.target).parent().hasClass("car-card"))
        if (obj.hasClass("has-submenu") && !($(e.target).hasClass("submenu__link")) && !ifcarCard) {
          e.preventDefault();
        }
      }
      if (!obj.hasClass("is-opened") && subcontent.length) {
        hideOpened();
        obj.addClass("is-opened");
        subcontent.fadeIn();
        $("body").addClass("no-overflow");
        $("body").css({ "padding-right": scrollbarWidth + "px" });

        //var subcontentPosition = $('.header__bottom').hasClass('_fixed') ? bottomHeaderHeight : headerHeight;
        var subcontentPosition = bottomHeaderHeight;
        subcontent.css({
          "top": `${subcontentPosition}px`
        });
        /*Запуск загрузки списка машин для первого
          в списке элемента (дефолтного)*/
        /*if (subcontent.find(".js-get-cars-list").length) {
          subcontent.find(".js-get-cars-list").eq(0).trigger("click");
        } else if (subcontent.parent().find(".js-get-cars-list") && vw > 1024) {
          subcontent.parent().find(".js-get-cars-list").trigger("click");
        }*/
      } else if (!isOnSubcontent($(e.target))) {
        hideOpened();
        $("body").removeClass("no-overflow");
        $("body").css({ "padding-right": "0" });

      }

      if (submenu.length) {
        var cont = submenu.parents(".js-services-list-item");
        submenuPosition(submenu, cont);
        submenu.fadeIn("fast");
      }
    }


  $(".subcontent .close").on("click", function (e) {
      $(".js-fader").fadeOut("300");
      $("body").removeClass("no-overflow");
      hideOpened();
      e.stopPropagation();
  });


    $(document).on("click", ".js-services-list-item a.car-card", function(e) {
      e.stopPropagation();
    })

    var menuPos = $('.header__bottom').offset().top;
    var docPos = $(document).scrollTop();

    $(document).on('scroll', function() {
      var headerHeight = $(".header").outerHeight();
      var bottomHeaderHeight = $('.header__bottom').outerHeight();
      var subcontent = $('.subcontent');

      docPos = $(document).scrollTop();
      if ($(window).width() >= 768) {
        if (docPos >= menuPos) {
          $('.header__top, .header__bottom').addClass('_fixed');
          subcontent.css({ "top": `${bottomHeaderHeight}px` })
        } else {
          $('.header__top, .header__bottom').removeClass('_fixed');
          subcontent.css({ "top": `${headerHeight}px` })
        }
      }
    });

    function openSubcontent(cont, contList) {
      var subcontent = cont.find(".subcontent");
      var bottomInfo = $(".main-nav__menu-bottom");
      var screenHeight = $(window).outerHeight();
      var scrollcont = subcontent.find(".js-scrollable");
      var backLink = subcontent.find(".js-mob-back");

      contList.css({
        "transform": "translateX(-100%)"
      })

      if (scrollcont.length) {
        scrollable(scrollcont);
      }

      bottomInfo.fadeOut();
      subcontent.fadeIn();
      subcontent.css({
        "transform": "translateX(100%)"
      });
      backLink.on("click", function(e) {
        closeSubcontent(cont, contList)
      });
    }

    function closeSubcontent(cont, contList) {

      var subcontent = cont.find(".subcontent")
      var bottomInfo = $(".main-nav__menu-bottom");
      subcontent.fadeOut();
      subcontent.css({
        "transform": "translateX(200%)"
      })
      bottomInfo.fadeIn();
      contList.css({
        "transform": "translateX(0)"
      })
      cont.off("click");
      setTimeout(function() {
        cont.on("click", function(e) {
          e.preventDefault();
          openSubcontent($(this), contList)
        })
      }, 0)
    }

    function hideOpened() {
      $(".is-opened").each(function() {
        $(this).find(".subcontent").fadeOut();
        $(this).removeClass("is-opened");
        $(this).find('.is-clicked').removeClass('is-clicked');

      })
    }

    function submenuPosition(submenu, cont) {
      var contLeft = cont.offset().left;
      var contWidth = cont.width();
      var headerHeight = $(".header").outerHeight();
      var contHeight = cont.parent().outerHeight();
      submenu.css({
        "left": `${contLeft}px`,
        "min-width": `${contWidth}px`,
        "top": `${headerHeight - contHeight/2}px`
      })
    }

    $('.js-mob-showmore').on('click', function(event) {
      event.stopPropagation();
    });
  }

function scrollable(cont) {
  var vw = $(window).width();
  //scrollCont - это внутренний див, который будет непосредственно скроллиться
  //cont - Это внешняя обертка, она сама не скролиться, а выступает лишь в
  //       качестве обертки. Это нужно для адекватного отображения градиента,
  //       прятяющего нижнюю границу.

  var scrollCont = cont.children(".scrollable__inner");
  $(scrollCont).each(function(index){
    new PerfectScrollbar(scrollCont[index], {
      suppressScrollX: true
    });
  })

  //set shadow on bottom if needed
  if (!cont.data("no-shadow")) {
    setShadows(cont);
  }

  function setShadows(cont){
    var topShadow = $("<div></div>", {
      class:"scrollable__topShadow"
    })
    var bottomShadow = $("<div></div>", {
      class:"scrollable__bottomShadow"
    })

    /*пока просто ставим без проверки на переполнение*/

    cont.append(bottomShadow);
    topShadow.hide();
    cont.append(topShadow);


    scrollCont.each(function(){
      $(this).on("ps-y-reach-end", function () {
        $(this).closest(".js-cars-cont").find(".scrollable__bottomShadow").fadeOut(100);
      });
      $(this).on("ps-scroll-up", function () {
        $(this).closest(".js-cars-cont").find(".scrollable__bottomShadow").fadeIn(100);
      });
      $(this).on("ps-y-reach-start", function () {
        $(this).closest(".js-cars-cont").find(".scrollable__topShadow").fadeOut(100);
      });
      $(this).on("ps-scroll-down", function () {
        $(this).closest(".js-cars-cont").find(".scrollable__topShadow").fadeIn(100);
      });
    })
  }

  if (vw < 768) {
    scrollCont.css({
      "height" : $(window).outerHeight() - 105 + 'px'
    })
  }
}

function sfm(e) {
    if (e.matches) {
      return true;
    }
    else{
      return false;
    }
}

var sf_style = window.matchMedia("(min-width: 768px)");
sf_style.addListener(sfm);
sfm(sf_style);


function menu() {
  $(".js-mob-menu-open").on("click", function(){
    var target = $(this).data("target");
    openMobMenu(target);
  })



  $(".js-fader, .js-mob-menu-close").on("click", function () {
    if (!sfm(sf_style)) closeOpenedMenu();
  });

  $(document).on("click", function (e) {
    var menu_div = $(".main-nav__item *, div.subcontent");
    var submen=$(".js-services-list-item-sb");
    if (sfm(sf_style) && $("body").hasClass("no-overflow") && !menu_div.is(e.target) && menu_div.has(e.target).length === 0) {
      closeOpenedMenu();
    }
    if(sfm(sf_style) && !submen.is(e.target) && submen.has(e.target).length === 0 && submen.find(".submenu")){
      submen.find(".submenu").fadeOut("fast");
    }
  });


    fixOnScroll($(".js-mob-menu-open"));
    fixOnScroll($(".header__right"));


  function fixOnScroll(el){
    var elTop = el.offset().top;
    $(window).on("scroll", function(){
      if ($(window).width() < 768) {
        if ($(window).scrollTop() > elTop) {
          el.addClass("fixed");
        } else {
          el.removeClass("fixed");
        }
      }
    })

  }

  function openMobMenu(target) {
    var targetObj = $(`.js-mob-menu[data-menu="${target}"]`)
    $(".js-fader").fadeIn("300");
    $("body").addClass("no-overflow");
    targetObj.css({
      "transform" : "translateX(0)",
      "transition": "transform 0.3s"
    })
    targetObj.addClass("menu-opened")
    $(window).trigger("scroll")
    if(targetObj.data("scroll") != undefined) {
      var scrollCont = targetObj.children(".scrollable");
      new PerfectScrollbar(scrollCont[0], {
        suppressScrollX: true
      });
    }


  }
  function closeOpenedMenu(){
    $(".js-fader").fadeOut("300");
    $("body").removeClass("no-overflow");
    $("body").css({"padding-right": "0"});
    $(".menu-opened").css({
      "transform" : "translateX(-150%)"
    })
  }
}

function loadCarsList(){

  $(".js-mob-back-second").on("click", function(){
    $(".subcontent__services-cont").css({
      "transform": "translateX(0)"
    })
    $(".js-cars-cont").css({
      "transform": "translateX(100%)"
    })
  })

   $( document ).ready(function() {
    $(document).on("click", ".js-services-list-item", function (event) {
      event.stopPropagation();
      var vw = $(window).width();
      var url = $(this).data("url") ? $(this).data("url") : $(this).find('.subcontent__container').data("url");
      switch (vw < 768) {
        /*mobile handle*/
        case true:
          var slideStep = $(this).data("url") ? -87 : 0;
          $(this).parents(".subcontent__services-cont").css({
            "transform": "translateX(-120%)"
          });
          $(".js-cars-cont").css({
            "transform": "translateX(" + slideStep + "%)"
          });
          loadIt(url, $(this));
          break;
        /*desktop handle*/
        case false:
          loadIt(url, $(this));
          break;
      }

      //setTimeout - имитируем время получение ответа от сервера.
    });
  });

  function cleanCont(){
    $(".js-cars-cont").find(".cars").remove();
    $(".scrollable__bottomShadow").remove();
    $(".scrollable__topShadow").remove();
    if (!sfm(sf_style)) {
      $(".js-loader").fadeIn();
    } else {
      $(".js-loader").fadeIn('fast');
    }
  }

  function getActive(el) {
    $(".services__item.active").removeClass("active");
    if (el.parent().hasClass('services__item')) {
      el.parent().addClass("active");
    }
  }

  function loadIt(url,el) {
    if (!$(".js-cars-cont").hasClass("is-loading")) {
      $(".js-cars-cont").addClass("is-loading");
      getAndAppend(url);
      getActive(el);
      cleanCont();
    }
  }

  function getAndAppend(url) {
    if (sfm(sf_style)) {
      var stt = 0;
    } else {
      var stt = 1000;
    }
    $.ajax({
      url: url,
      type: "GET",
      beforeSend: function(){
        if (sfm(sf_style)) {
          $(".js-loader").fadeIn('fast');
        }
      },
      success: function success(answer) {
        setTimeout(function () {
          if (!sfm(sf_style)) {
            $(".js-loader").fadeOut();
          } else {
            $(".js-loader").fadeOut('fast');
          }
          $(".js-cars-cont").append(answer);
          scrollable($(".js-cars-cont"));
          $(".js-cars-cont").removeClass("is-loading");
        }, stt);
      },
      error: function error(e) {
        console.log(e);
      }
    });
  }
}

function servicesTabInit () {

	$('.js-services-tab').on('click',  function(event) {

		var category = $(this).data('service');
		$('.js-tab-content' + '[data-service="' + category + '"]')
			.show()
			.siblings('.js-tab-content')
			.hide();

		$('.js-services-img' + '[data-service="' + category + '"]')
			.show()
			.siblings('.js-services-img')
			.hide();



		$(this).addClass('is-active')
				.siblings('.js-services-tab')
				.removeClass('is-active');

	});
}
function formFileInit() {
	//отправка формы обратной связи из Контакты
	$(".form").on("click", "#submit_btn3", function(e) {
		if (window.yaCounter23103697) yaCounter23103697.reachGoal("enrollonline:contacts");
		
		var validateOpts = $.extend({}, mainValidateOpts);

		validateOpts.submitHandler = function(form, e) {
			e.preventDefault();

			$("#secur_chk2").val("Y");
			// var fields = $("#want_form3").serialize();


			// $(".form").load('/modal_includes/contacts_request.php',fields,function(){
			//     activate_phone();
			// });

			$(".form").ajaxSubmit({
				success: function(response) {
					activate_phone();
				}
			});

			return false;
		}

		$(this).closest('.form').find('#want_form3').validate(validateOpts);
	});
}



function smoothScroll() {
    $('.js-scroll-link').click(function(ev) {
      if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'')
          || location.hostname == this.hostname)
      {
          let target = $(this.hash);
          console.log(target, ' target');
        const headerHeight = $('.js-sticky-header').height() + 5; // Get fixed header height

        target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
      console.log(target,' target 2');
        if (target.length)
        {
          $('html,body').animate({
            scrollTop: target.offset().top - headerHeight
          }, 500);
          return false;
        }
      }
  });
}


$(function() {



    const initScrollToTop = () => {

        const scrollBlock = document.createElement('div'),

              windowHeight = document.documentElement.clientHeight;

        scrollBlock.classList.add('scroll-to-top');

        document.body.append(scrollBlock);

        scrollBlock.innerHTML = `

        <svg width="20" height="31" viewBox="0 0 20 31" fill="none" xmlns="http://www.w3.org/2000/svg">

            <path fill-rule="evenodd" clip-rule="evenodd" d="M9.29289 0.792893C9.68342 0.402369 10.3166 0.402369 10.7071 0.792893L19.7071 9.79289C20.0976 10.1834 20.0976 10.8166 19.7071 11.2071C19.3166 11.5976 18.6834 11.5976 18.2929 11.2071L11 3.91421V29.5C11 30.0523 10.5523 30.5 10 30.5C9.44771 30.5 9 30.0523 9 29.5V3.91421L1.70711 11.2071C1.31658 11.5976 0.683417 11.5976 0.292893 11.2071C-0.0976311 10.8166 -0.0976311 10.1834 0.292893 9.79289L9.29289 0.792893Z" fill="#C8D6E4"/>

        </svg>

        `



        scrollBlock.addEventListener('click', () => {

            window.scrollTo({

                top: 0,

                behavior: 'smooth',

            })

        })



        document.addEventListener('scroll', () => {

            if (document.documentElement.scrollTop >= windowHeight * 1.5 &&  document.documentElement.scrollTop + windowHeight / 2 >= document.body.scrollHeight / 2) {

                scrollBlock.classList.add('active')

            } else {

                scrollBlock.classList.remove('active')

            }

        })

    }



    if (document.querySelector('.block.calc.calc_model.page')) {

        const forms = document.querySelectorAll('.block.calc.calc_model.page');



        forms.forEach(form => {

            var formBg = form.querySelector('.form__calc-bg');



            if (formBg) {

                formBg.style.display = 'none';

            }

        })

    }



    if (document.querySelector('.phone-fixed')) {

        const paddingMenu = document.querySelector('.phone-fixed').clientHeight;



        document.querySelector('.new-header .main-nav__scrollable').style.paddingBottom = paddingMenu + 'px';

    }



    if (!document.querySelector('.js-scroll-up')) {

        initScrollToTop();

    }



    function validateFieldForm() {

        document.addEventListener('input', (e) => {

            if (e.target.name === 'NAME') {

                e.target.value = e.target.value.replace(/[^a-zа-я]/gi, '');

            }

        })

    }



    validateFieldForm();



  if ($(".js-gallery-slider").length){

   gallerySliderInit();

  }



  if ($(".js-services-tab").length){

   servicesTabInit()

  }



  var vw = $(window).width();

  if (vw >= 768) {

    servicesList();

    if ($(".js-scrollable").length) {

      $(".js-scrollable").each(function(){

        scrollable($(this));

      })

    }

  }



  loadCarsList();

  mainNav();

  menu();

  smoothScroll();



  if ($(".js-main-slider").length){

    mainSliderInit();

  }



  if ($(".js-service-slider").length){

	specialService();

  }

  if ($(".reviews-slider").length){

	reviewsSlider();

  }



    if ($(".similar-errors-slider").length) {

        otherErrorsSliderInit();

    }



  $(".js-tags-list-more").on("click", function() {

    $(this).closest(".js-tags-list").toggleClass("is-expand");

  });



  // Тултипы обратной связи - contacts.html

  // const tmplFeedbackTooltip = document.getElementById(`feedback-tooltip`);



  // Тултип шаринга в соцсетях



  // объект для шаринга

  let shareState = {

    url: '',

    title: '',

    img: '',

    text: '',

  };



  // собственно тултип



  function createTooltip({url='', title='', img='', text=''}) {

    return  `<div class="tooltip-share">

    <ul class="tooltip-share__list">

      <li class="tooltip-share__item">

          <a href="#" class="tooltip-share__link js-shared-link" data-site="twitter" data-url="${url}" data-title="${title}" data-desc="${text}" data-img="${img}">

              <svg class="tooltip-share__icon">

                  <use xlink:href="#twitter"></use>

              </svg>

          </a>

      </li>

      <li class="tooltip-share__item">

          <a href="#" class="tooltip-share__link js-shared-link" data-site="telegram" data-url="${url}" data-title="${title}" data-desc="${text}" data-img="${img}">

              <svg class="tooltip-share__icon">

                  <use xlink:href="#telegram"></use>

              </svg>

          </a>

      </li>

      <li class="tooltip-share__item">

          <a href="#" class="tooltip-share__link js-shared-link" data-site="facebook" data-url="${url}" data-title="${title}" data-desc="${text}" data-img="${img}">

              <svg class="tooltip-share__icon">

                  <use xlink:href="#facebook"></use>

              </svg>

          </a>

      </li>

      <li class="tooltip-share__item">

          <a href="#" class="tooltip-share__link js-shared-link" data-site="vk" data-url="${url}" data-title="${title}" data-desc="${text}" data-img="${img}">

              <svg class="tooltip-share__icon">

                  <use xlink:href="#vk"></use>

              </svg>

          </a>

      </li>

      <li class="tooltip-share__item">

          <a href="#" class="tooltip-share__link js-shared-link" data-site="pinterest" data-url="${url}" data-title="${title}" data-desc="${text}" data-img="${img}">

              <svg class="tooltip-share__icon">

                  <use xlink:href="#pinterest"></use>

              </svg>

          </a>

      </li>

      <li class="tooltip-share__item">

          <svg class="tooltip-share__icon">

              <use xlink:href="#share"></use>

          </svg>

      </li>

    </ul>

</div>

`

  }



  // при показе заново создается тултип с правильными data атрибутами

  const tooltipItems = document.querySelectorAll('.js-tooltip-item');

  tooltipItems.forEach((el) => {

      const triggerEl = el.querySelector('.js-tooltip-trigger');



      tippy(el, {

        theme: 'light',

        interactive: true,

        allowHTML: true,

        content: createTooltip(shareState),

        placement: 'bottom-end',

        offset: [0, 0],

        maxwidth: 280,

        triggerTarget: triggerEl,

        arrow: false,

        zIndex: 1000,

        onShow(instance) {

            const shareState = instance.reference.dataset;

            instance.setContent(createTooltip(shareState))

        },

        popperOptions: {

            modifiers: [

              {

                name: 'flip',

                enabled: false,

              },

            ],

          },

      });

  })



  // генерируем url



  const Share = {

	vkontakte: function(purl, ptitle, pimg, text) {

        let url  = 'http://vkontakte.ru/share.php?';

		url += 'url='          + encodeURIComponent(purl);

		url += '&title='       + encodeURIComponent(ptitle);

		url += '&description=' + encodeURIComponent(text);

		url += '&image='       + encodeURIComponent(pimg);

		url += '&noparse=true';

		Share.popup(url);

	},

	facebook: function(purl, ptitle, pimg, text) {

		let url  = 'http://www.facebook.com/sharer.php?s=100';

		url += '&p[title]='     + encodeURIComponent(ptitle);

		url += '&p[summary]='   + encodeURIComponent(text);

		url += '&p[url]='       + encodeURIComponent(purl);

		url += '&p[images][0]=' + encodeURIComponent(pimg);

		Share.popup(url);

	},

	twitter: function(purl, ptitle) {

		let url  = 'http://twitter.com/share?';

		url += 'text='      + encodeURIComponent(ptitle);

		url += '&url='      + encodeURIComponent(purl);

		url += '&counturl=' + encodeURIComponent(purl);

		Share.popup(url);

	},

	pinterest: function(purl, pimg, text) {

		let url  = 'http://www.pinterest.com/pin/create/button/?';

		url += 'url='      + encodeURIComponent(purl);

		url += '&media='      + encodeURIComponent(pimg);

		url += '&description=' + encodeURIComponent(text);

		Share.popup(url);

	},

    telegram: function(purl, text) {

        let url  = `https://telegram.me/share/url?`;

        url += `url=`      + encodeURIComponent(purl);

        url += `&text=` + encodeURIComponent(text);

        Share.popup(url);

    },



	popup: function(url) {

		window.open(url,'','toolbar=0,status=0,width=626,height=436');

	},

};





document.addEventListener('click', function(ev) {

    const target = ev.target.closest('.js-shared-link');

    if(!target) return;

    const site = target.dataset.site;



    switch(site) {

        case 'twitter':

            Share.twitter(target.dataset.url, target.dataset.title);

            break;

        case 'facebook':

            Share.facebook(target.dataset.url, target.dataset.desc);

            break;

        case 'vk':

            Share.vkontakte(target.dataset.url, target.dataset.title, target.dataset.img, target.dataset.desc);

            break;

        case 'pinterest':

            Share.pinterest(target.dataset.url, target.dataset.img, target.dataset.desc);

            break;

        case 'telegram':

            Share.telegram(target.dataset.url, target.dataset.desc);

            break;

        default:

    }



});



// шаринг: отключить переход по ссылке на мобильном

    $('.js-tooltip-trigger').on('click', function(ev) {

        ev.preventDefault();

    })





    $(`.js-comment-form`).on(`submit`, function(e) {

        e.preventDefault();



        const $this = $(this);



        $.ajax({

            type: `POST`,

            url: $this.data(`url`),

            data: $this.serialize(),



            success: (data) => {

               $this[0].reset();

               const containerMessage = document.querySelector('.js-comment-form .subscribe-form__item');



               if (containerMessage) {

                    let div = document.querySelector('.js-comment-form .success__message')

                    if (!div) {

                        div = document.createElement('div');

                        div.className = 'success__message';

                        div.textContent = 'Вы подписались на рассылку';

                        containerMessage.append(div);

                    }



                    setTimeout(() => {

                        div.classList.add('active');

                    })



                    setTimeout(() => {

                        div.classList.remove('active');

                    }, 5000);

               }

            },

            error: (request) => {

                $this[0].reset();

            }

        });

    });



    // сокращает строки





    function truncateDesc(mode) {

        const truncateElements = document.querySelectorAll('.js-truncate-desc');



        if(mode === 'small') {

            truncateElements.forEach(el => {

                // у большой 6, у остальных 2

                const linesCount = el.dataset.lines == 11 ? 6 : 2;

                $clamp(el, {clamp: linesCount});

            });

            return

        }



        truncateElements.forEach(el => {

            const linesCount = el.dataset.lines

            $clamp(el, {clamp: linesCount});

        });

    }



    function truncateTitle() {

        const truncateElements = document.querySelectorAll('.js-truncate-title');



        truncateElements.forEach(el => {

            const linesCount = el.dataset.lines

            $clamp(el, {clamp: linesCount});

        });

    }



    let truncateMode = window.innerWidth <= 1280 ? 'small' : 'default';

    truncateTitle();

    truncateDesc(truncateMode);



    window.addEventListener('resize', function() {

        const newMode = window.innerWidth <= 1280 ? 'small' : 'default';

        if(newMode === truncateMode) return



        truncateDesc(newMode);

        truncateMode = newMode;

    });

})





window.addEventListener('load', () => {

    function testWebP(callback) {

        let webP = new Image();

        webP.src = 'data:image/webp;base64,UklGRjoAAABXRUJQVlA4IC4AAACyAgCdASoCAAIALmk0mk0iIiIiIgBoSygABc6WWgAA/veff/0PP8bA//LwYAAA';

        webP.onload = webP.onerror = function () {

            callback(webP.height === 2);

        };

    };



    setTimeout(() => {

        testWebP(function(support) {

            console.log(support);

            if (!support) {

                const allImg = document.querySelectorAll('img');



                allImg.forEach(img => {

                    let srcImage = img.src;

                    if (srcImage && srcImage.endsWith('.webp')) {

                        if (img.dataset.src) {

                            srcImage = img.dataset.src;

                        }



                        const newSrcImage = srcImage.substring(0, srcImage.length - 5);



                        img.setAttribute('src', newSrcImage);

                    } else if (img.dataset.src) {

                        console.log(img);

                        srcImage = img.dataset.src;



                        const newSrcImage = srcImage.substring(0, srcImage.length - 5);



                        img.setAttribute('src', newSrcImage);

                    }

                })

            }

        });

    }, 800)





    //zoom страницы для широких экранов

    $(document).ready(function ($) {



        nsZoomZoom();



        $(window).resize(function () {

            nsZoomZoom();

        });



        function nsZoomZoom() {

            let htmlWidth = $('html').innerWidth();

            let bodyWidth = 1920;



            let scale = htmlWidth < bodyWidth ? 1 : htmlWidth / bodyWidth;



            $("body").css('zoom', scale);

            $("body").css('-ms-zoom', scale);

            $("body").css('-moz-transform', 'scale(' + scale + ')');

        }

    });







    let scrollLinks = document.querySelectorAll('a[href="#menu-scroll__price"], a[href="#menu-scroll__also"], a[href="#menu-scroll__gallery"]');



    function makeAnchors() {

        const articlePageWrapper = document.querySelector('.article section');

        const originalHeaders = document.querySelector('article section .article-nav .article-nav__inner');



        if(originalHeaders) { // если в DETAIL_TEXT уже есть содержание, ничего не делаем

            return;

        }

        

        if (!articlePageWrapper) {

            return;

        }

        const ul = document.querySelector('article.article .js-article-nav__inner');

        console.log()

        if (!ul || !articlePageWrapper) {

            return;

        }

        const headers = articlePageWrapper.querySelectorAll('h2, h3');

        const contentHeaders = [];

        headers.forEach((header, index) => {

            console.log(header, ' header');

            header.id = `section-${index}`;

        });



        // if (headers.length !== 0) {

        //     content.classList.remove('detail-article__contents--hidden');

        // }

    }



    makeAnchors();



    // Добавляем обработчик события click для каждой ссылки

    scrollLinks.forEach(function(link) {

        link.addEventListener('click', function(e) {

            e.preventDefault();



            // Получаем цель (id элемента, к которому нужно прокрутить)

            var targetId = this.getAttribute('href').substring(1);

            var targetElement = document.getElementById(targetId);



            // Прокручиваем страницу к цели с плавным скроллом

            targetElement.scrollIntoView({

                behavior: 'smooth'

            });

        });

    });



    function copyTextToClipboard(text, promiseReturn = false) {

        if (!navigator.clipboard) {

            return fallbackCopyTextToClipboard(text);

        }



        if (promiseReturn) {

            return navigator.clipboard.writeText(text);

        }



        navigator.clipboard.writeText(text).then(() => {

            console.log('Значение успешно скопировано');

            return true;

        }, (err) => {

            console.error('Ошибка при копировании: ', err);

            return false;

        })

    }



    function fallbackCopyTextToClipboard(text) {

        const textArea = document.createElement('textarea');

        textArea.value = text;



        textArea.style.bottom = '0';

        textArea.style.right = '0';

        textArea.style.position = 'fixed';

        debugger;

        document.body.appendChild(textArea);

        textArea.focus();

        textArea.select();



        let success = false;



        try {

            const copyRes = document.execCommand('copy');



            let copyMsg = 'неуспешно';



            if (copyRes) {

                success = true;

                copyMsg = 'успешно';

            }



            console.log('Копирование значения ' + copyMsg);

        } catch (err) {

            console.error('Копирование завершено с ошибкой: ', err);

        }



        document.body.removeChild(textArea);



        return success;

    }



    if(window.location.href.includes('/blog/')) {

        function setCopyLink() {

            const copyLinkElement = document.querySelectorAll('.js-share-list__item--link-copy');

            console.log(copyLinkElement,' like element');

            copyLinkElement.length > 0 && copyLinkElement.forEach(item => item.addEventListener('click', () => {

                copyTextToClipboard(window.location.href);



                const copiedMessage = item.querySelector('.js-share-list__share-message');

                console.log(copiedMessage)



                if (copiedMessage) {

                    copiedMessage.classList.add('_copied');



                    setTimeout(() => {

                        copiedMessage.classList.remove('_copied');

                    }, 3000);

                }

            }));

        }

        setCopyLink();

    }



})


